var CheckoutStepErrorType;
(function(CheckoutStepErrorType) {
    CheckoutStepErrorType["Failed"] = 'failed';
    CheckoutStepErrorType["ShippingStepFailed"] = 'shipping-step-failed';
})(CheckoutStepErrorType || (CheckoutStepErrorType = {}));

export { CheckoutStepErrorType };
//# sourceMappingURL=checkout-step-error-type.js.map
